// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"component-input"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 8L3 8L3 15L21 15V8Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 11V12M3 8H21V15H3V8Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ComponentInputIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-input',
    ref,
    icon: element,
  },
));

ComponentInputIcon.displayName = 'ComponentInputIcon';

export default ComponentInputIcon;
